import { render, staticRenderFns } from "./NoteUrl.vue?vue&type=template&id=f2fc0ee0&scoped=true"
import script from "./NoteUrl.vue?vue&type=script&lang=js"
export * from "./NoteUrl.vue?vue&type=script&lang=js"
import style0 from "./NoteUrl.vue?vue&type=style&index=0&id=f2fc0ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fc0ee0",
  null
  
)

export default component.exports